import mockStores from './stores.mock';

const { httpStatus } = require('../../../../services/fetch/httpStatuses');


function toggleFilter(value, valueGetter) {
  const toggleValue = !!value;
  return function filter(item) {
    return !toggleValue || (toggleValue && valueGetter(item) === toggleValue);
  };
}

function typesFilter(types) {
  const typesArray = types && types.split(',');
  return function filter(item) {
    return !types || (types && typesArray.includes(item.type));
  };
}

function arrayFilter(condition, arrayGetter, valueGetter) {
  const arrayWithValues = condition && condition.split(',');
  return function filter(store) {
    return !condition || (valueGetter(store).filter((item) => arrayWithValues.includes(valueGetter(item))));
  };
}

export default {
  onFetching: (params) => {
    const filteredStores = mockStores
      .filter(typesFilter(params.types))
      .filter(toggleFilter(params.closedOnSaturday, (item) => item.closedOnSaturday))
      .filter(toggleFilter(params.closedOnSunday, (item) => item.closedOnSunday))
      .filter(toggleFilter(params.payAndCollectAvailable, (item) => item.payAndCollectAvailable))
      .filter(arrayFilter(params.facilities, (item) => item.facilities, (item) => item.code))
      .filter(arrayFilter(params.services, (item) => item.services, (item) => item.code))
      .filter((item, index, self) => self.indexOf(item) === index)
      .slice(0, params.maxCount || 3);

    return {
      payload: {
        stores: filteredStores
      }
    };
  },
  onFetched: (data, params) => {
    if (data && data.error) {
      return httpStatus.NotFound;
    }

    return httpStatus.OK;
  }
};
